import React from 'react'
import BarreTop from './BarreTop'
import PropTypes from "prop-types";
import entete from "../../assets/img/entete_pool.png"

const DocumentHeader = (props) => {
    const { typeOrganisme, logoPreviewUrl } = props;

    return (
        <div style={{ flexShrink: 0 }}>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "0px 0px",
                }}
            >
                {typeOrganisme !== "POOL" && logoPreviewUrl && (
                    <img
                        src={logoPreviewUrl}
                        style={{
                            width: typeOrganisme !== "POOL" && logoPreviewUrl ? "50%" : "100%",
                            height: "105px",
                            objectFit: "contain"
                        }}
                        alt="Logo"
                    />
                )}

                <img
                    src={entete}
                    style={{
                        width: typeOrganisme !== "POOL" && logoPreviewUrl ? "50%" : "100%",
                        height: "105px",
                        objectFit: "contain"
                    }}
                    alt="Header"
                />
            </div>
            {BarreTop && <BarreTop />}
        </div>
    )
}
DocumentHeader.propsTypes = {
    typeOrganisme: PropTypes.string,
    logoPreviewUrl: PropTypes.string,
    entete: PropTypes.string,
}

export default DocumentHeader